import { render } from "./ChatInputContainer.vue?vue&type=template&id=d7e4c898&scoped=true&lang=pug"
import script from "./ChatInputContainer.vue?vue&type=script&lang=js"
export * from "./ChatInputContainer.vue?vue&type=script&lang=js"

import "./ChatInputContainer.vue?vue&type=style&index=0&id=d7e4c898&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7e4c898"]])

export default __exports__